import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import pluralize from 'pluralize';

import { getCheckoutCart } from '../../../redux/checkoutSelectors';
import { togglePrintPartnerOrderServiceCartItem } from '../../../redux/checkoutActions';
import { getAlbumMembershipGroupPrintPartnerOrderServices } from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/helpers';
import CART_ITEM from '../../../constants/cartItems';
import CustomControl from '../../../../../components/global/CustomControl';
import { getPrintPartnerOrderServiceCartItem } from '../../../redux/helpers';
import CheckoutCartItemPriceDisplay from '../../CheckoutCartItem/CheckoutCartItemPriceDisplay';

const propTypes = {
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  onPrintPartnerOrderServiceToggle: PropTypes.func,
  itemsPriceBreakdown: PropTypes.array,
  loadingPricing: PropTypes.bool,
  cart: PropTypes.array,
};
const CheckoutPrintOrderServices = ({
  albumMembershipGroup,
  onPrintPartnerOrderServiceToggle,
  itemsPriceBreakdown,
  loadingPricing,
  cart,
}) => {
  const printPartnerOrderServices = useMemo(
    () =>
      getAlbumMembershipGroupPrintPartnerOrderServices(albumMembershipGroup),
    [albumMembershipGroup],
  );

  const hasPrintItems = useMemo(
    () =>
      cart.some(item =>
        [
          CART_ITEM.INDIVIDUAL_PRINT,
          CART_ITEM.PRINT_PRODUCT,
          CART_ITEM.ALBUM_PRINT_PACKAGE,
          CART_ITEM.ALBUM_CUSTOM_PRINT,
          CART_ITEM.PURCHASED_CUSTOM_PRINT,
          CART_ITEM.PURCHASED_PHOTO_PRICING_PRINT_PRODUCT,
        ].includes(item.type),
      ),
    [cart],
  );

  if (
    !albumMembershipGroup ||
    !printPartnerOrderServices?.length ||
    !cart?.length ||
    !hasPrintItems
  ) {
    return null;
  }

  return (
    <div className="checkout-cart-item print-partner-order-service-item">
      <div className="checkout-cart-item-title d-block mb-2">
        Upgrade your order with the following{' '}
        {pluralize('service', printPartnerOrderServices.length)}:
      </div>
      {printPartnerOrderServices.map(printPartnerOrderService => {
        const {
          print_order_service: printOrderService,
        } = printPartnerOrderService;

        const item = getPrintPartnerOrderServiceCartItem(cart, {
          printPartnerOrderServiceId: printPartnerOrderService.id,
        });

        const pricing = itemsPriceBreakdown.find(
          priceBreakdown => priceBreakdown.checkout_item_client_id === item?.id,
        );

        return (
          <CustomControl
            type="checkbox"
            shape="squared"
            size="sm"
            className="text-dark"
            label={
              <div>
                <span>{printOrderService.name}</span>
                <CheckoutCartItemPriceDisplay
                  className="ml-2"
                  clientPrice={printPartnerOrderService.price}
                  pricing={pricing}
                  loading={loadingPricing}
                />
              </div>
            }
            key={printPartnerOrderService.id}
            onClick={e => {
              e.stopPropagation();
              onPrintPartnerOrderServiceToggle({
                albumMembershipGroup,
                printPartnerOrderService,
              });
            }}
            checked={!!item}
          />
        );
      })}
    </div>
  );
};

CheckoutPrintOrderServices.propTypes = propTypes;

const mapStateToProps = state => ({
  cart: getCheckoutCart(state),
});

const mapDispatchToProps = {
  onPrintPartnerOrderServiceToggle: togglePrintPartnerOrderServiceCartItem,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CheckoutPrintOrderServices,
);
